// behaves like _.negate
type INegate = <T extends any[]>(predicate: (...args: T) => boolean) => (...args: T) => boolean

const negate: INegate
  = predicate =>
    (...args) =>
      !predicate(...args)

export { negate }
